import { render } from "./TagManager.vue?vue&type=template&id=41d1b7a0"
import script from "./TagManager.vue?vue&type=script&lang=js"
export * from "./TagManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__